import { Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

import {
  Icon,
  Modal,
  Sidebar as SidebarCore,
  LogoutButton,
} from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { useAuth } from '@hooks';
import { UserType } from '@contexts';
import { HomeRouter } from '@flows/private/home/router';

import {
  BackofficeManagement,
  CanceledPartnerCompanyAlert,
  SidebarContent,
} from './components';

export function Sidebar() {
  const { user, logOut } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const [showLogoutConfirmationState, setShowLogoutConfirmationState] =
    useState<boolean>(false);
  const handleLogoutConfirmation = () =>
    setShowLogoutConfirmationState(!showLogoutConfirmationState);

  const isBackoffice = user?.companyType === UserType.Backoffice;

  const navigateToHome = () => {
    navigate(HomeRouter.path);
  };

  return (
    <>
      <SidebarCore.Root
        anchor={isMobile ? 'right' : 'left'}
        isBackoffice={isBackoffice}
      >
        <SidebarCore.Header
          onClickLogo={navigateToHome}
          isColorful={!isBackoffice}
          userName={user?.name}
        />
        <SidebarCore.Content flex={1} gap={5}>
          <CanceledPartnerCompanyAlert />
          <Stack flex={1}>
            <SidebarContent />
          </Stack>
          <Stack gap={1}>
            {isBackoffice && <BackofficeManagement />}
            {isMobile && (
              <LogoutButton
                isBackoffice={isBackoffice}
                variant="text"
                startIcon={
                  <Icon
                    name="actions-b2b-logout"
                    color={NEW_COLORS.SECONDARY[500]}
                  />
                }
                onClick={handleLogoutConfirmation}
              >
                Sair
              </LogoutButton>
            )}
          </Stack>
        </SidebarCore.Content>
      </SidebarCore.Root>

      <Modal
        icon="actions-b2b-alert-octagon-filled"
        secondaryButtonText="Fechar"
        mainButtonText="Sair mesmo assim"
        title="Atenção! As informações não finalizadas poderão ser perdidas."
        mainAction={logOut}
        open={showLogoutConfirmationState}
        handleCloseModal={handleLogoutConfirmation}
      >
        <Typography variant="body1" fontSize={14}>
          Tem certeza que desejar sair?
        </Typography>
        <Typography variant="body1" fontSize={14}>
          Ao sair, informações não finalizadas poderão ser perdidas.
        </Typography>
      </Modal>
    </>
  );
}
